import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "COLOR_VARIABLE", {
  EDITED: "Color variable edited succesfully",
  DELETED: "Color variable deleted succesfully",
});
